import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/consumer/features/eye-bag-remover"
    exact
    path="/consumer/features/eye-bag-remover"
    component={AsyncPage}
  />,
];
